const menuData = [
	{
		id: '1',
		title: 'Главная',
		url: '/',
	},
	{
		id: '2',
		title: 'Участники и партнеры',
		url: '/partners',
	},
	{
		id: '3',
		title: 'ЗАКАЗЫ',
		url: '/draft',
	},
	{
		id: '4',
		title: 'Инжиниринговый центр',
		url: '/engineering',
	},
	{
		id: '5',
		title: 'Оборудование',
		url: '/plant',
	},

	{
		id: '6',
		title: 'Новости',
		url: '/news',
	},
	{
		id: '7',
		title: 'О нас',
		url: '/about',
	},
];
export default menuData;
